import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Zoom = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.55001 7.5002C2.55001 4.76639 4.7662 2.5502 7.50001 2.5502C10.2338 2.5502 12.45 4.76639 12.45 7.5002C12.45 10.234 10.2338 12.4502 7.50001 12.4502C4.7662 12.4502 2.55001 10.234 2.55001 7.5002ZM7.50001 1.4502C4.15869 1.4502 1.45001 4.15887 1.45001 7.5002C1.45001 10.8415 4.15869 13.5502 7.50001 13.5502C8.97264 13.5502 10.3224 13.024 11.3715 12.1495L13.6111 14.3891C13.8258 14.6039 14.1741 14.6039 14.3889 14.3891C14.6037 14.1743 14.6037 13.8261 14.3889 13.6113L12.1493 11.3717C13.0239 10.3225 13.55 8.97281 13.55 7.5002C13.55 4.15887 10.8413 1.4502 7.50001 1.4502Z"
        fill={color}
      />
    </svg>
  )
})

export default Zoom
